import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import ReportsIcon from "@/assets/icons/reports-icon.svg?react";
import { useGetDataFileReferencesQuery } from "@/redux/service";
import { DataFileReferenceResponse } from "@/redux/files/types";
import {
  DataFileReferencesProps,
  DataFileReferencesTypes,
} from "@/features/files/list/types";
import BaseTag from "@/components_v2/Tags/BaseTag";

const DataFileReferences = ({ fileId }: DataFileReferencesProps) => {
  const { t } = useTranslation();

  const {
    data: references,
    isSuccess,
    isLoading,
    isFetching,
  } = useGetDataFileReferencesQuery(fileId);

  const referencesTypes: DataFileReferencesTypes = {
    evidence: {
      title: t("datablocks.labels.evidence"),
      icon: ReportsIcon,
      getLink: (value: DataFileReferenceResponse) => `/evidence/${value.id}`,
    },
  };

  if (isLoading || isFetching) return <BaseSpinner />;

  return (
    isSuccess && (
      <div>
        {Object.entries(references).map(([referenceType, referenceDetails]) => {
          const referenceTypeDetails =
            referencesTypes[referenceType as keyof DataFileReferencesTypes];
          if (!referenceDetails) return;

          return (
            referenceDetails.length > 0 && (
              <div key={referenceType}>
                <div className="data-file-reference-label-container flex gap-100 items-center">
                  <referenceTypeDetails.icon />

                  <h6 className="body-s-medium">
                    {referenceTypeDetails.title}
                  </h6>
                </div>

                <ul>
                  {referenceDetails.map((value: DataFileReferenceResponse) => (
                    <li key={value.label}>
                      <span className="data-file-reference-list-item-container flex gap-200 items-center">
                        <Link
                          to={referenceTypeDetails.getLink(value)}
                          className="data-file-reference-list-item body-s-regular"
                        >
                          {value.label}
                        </Link>

                        <BaseTag
                          label={value.dataTemplate.title}
                          size="extra-small"
                          style={
                            value.dataTemplate.color
                              ? {
                                  backgroundColor: `${value.dataTemplate.color}33`,
                                  borderColor: value.dataTemplate.color,
                                }
                              : undefined
                          }
                        />
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )
          );
        })}
      </div>
    )
  );
};

export default DataFileReferences;
